import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-under-construction",
    templateUrl: "./under-construction.component.html",
    styleUrls: ["./under-construction.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnderConstructionComponent {
  @Output() closed = new EventEmitter<void>();
  title = "Under Construction";

  close() {
    this.closed.emit();
  }
}
